import { useControls } from "leva";
import { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import HologramMaterial from "../Materials/HologramMaterial/HologramMaterial";
import { useSelector } from "react-redux";

export default function Holograms(props) {
  const currentModule = useSelector((state) => state.progression.currentModule);
  const currentState = useSelector((state) => state.progression.currentState);
  const groupRef = useRef();

  const { nodes, materials } = useGLTF("/saviol-recherches-desk3.glb");

  // Contrôles Leva pour ajuster la rotation des hologrammes

  useGSAP(
    () => {
      if (groupRef.current && currentState === "TechnologyHub") {
        const tl = gsap.timeline();
        let meshSelected;

        groupRef.current.children.forEach((mesh) => {
          tl.to(
            mesh.material.uniforms.uFallOffThreshold,
            {
              value: 0,
              duration: 0.5,
              ease: "power2.out",
            },
            "<",
          ).to(
            mesh.scale,
            {
              x: 0,
              y: 0,
              z: 0,
              duration: 0.5,
              ease: "power2.out",
            },
            ">",
          );

          if (currentModule === mesh.module) {
            meshSelected = mesh;
          }
        });

        if (meshSelected) {
          tl.to(
            meshSelected.scale,
            {
              x: 0.3,
              y: 0.3,
              z: 0.3,
              duration: 0.75,
              ease: "power2.out",
            },
          ).to(
            meshSelected.material.uniforms.uFallOffThreshold,
            {
              value: 0.4,
              duration: 0.75,
              ease: "power2.inOut",
            },
            ">",
          );
        }
      }
    },
    { dependencies: [currentModule] },
  );

  return (
    <group {...props} ref={groupRef}>
      <mesh
        module={"holoA"}
        geometry={nodes.lens001.geometry}
        rotation={[5, 3.2, 2]}
        scale={0}
      >
        <HologramMaterial power={0.5} ></HologramMaterial>
      </mesh>
      <mesh
        module={"holoB"}
        geometry={nodes.lens002.geometry}
        rotation={[5, 3.2, 2]}
        scale={0}
      >
        <HologramMaterial power={0.5} ></HologramMaterial>
      </mesh>
      <mesh
        module={"holoC"}
        geometry={nodes.lens003.geometry}
        rotation={[5, -3.2, 2]}
        scale={0}
      >
        <HologramMaterial power={0.5}></HologramMaterial>
      </mesh>
      <mesh
        module={"holoD"}
        geometry={nodes.lens004.geometry}
        rotation={[5, -3.2, 2]}
        scale={0}
      >
        <HologramMaterial power={0.5}></HologramMaterial>
      </mesh>
    </group>
  );
}
